export default {
  fontIBMBold: 'DINPro-Bold, IBMPlexSans-Bold,  "Microsoft YaHei", Arial, sans-serif',
  fontIBMLight: 'DINPro-Light, IBMPlexSans-Light, "Microsoft YaHei", PingFangSC-Regular, Arial, sans-serif',
  fontIBMExtraLight: 'DINPro-Light, IBMPlexSans-ExtraLight, "Microsoft YaHei", PingFangSC-Regular, Arial, sans-serif',
  fontIBMSemiBold: 'DINPro-Medium, IBMPlexSans-SemiBold,  "Microsoft YaHei", Arial, sans-serif',
  fontIBMMedium: 'DINPro-Medium, IBMPlexSans-Medium,  "Microsoft YaHei", Arial, sans-serif',
  fontIBMRegular: 'DINPro, IBMPlexSans-Regular, "Microsoft YaHei", PingFangSC-Regular, Arial, sans-serif',
  contentMargin: '20px auto',
  maxWidth: '1260px',
  minWidth: '1200px',
  basictTradePageMaxWidth: '1260px',
  basictTradePageMinWidth: '1260px',
  fontSizeSm: '12px',
  fontSizeMd: '14px',
  fontSizeLg: '16px',
  fontSizeXl: '18px',
  fontSizeXxl: '20px',
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
};
